import { useEffect, useState } from "react";
import { v4Service } from "src/api";

export const useTokenInitializer = (storedDataKey: string) => {
  const [accessToken, setAccessToken] = useState<string | null>(null);

  useEffect(() => {
    if (!storedDataKey) return;

    const retrieveToken = async () => {
      const tokenData = await v4Service.retrieveData(storedDataKey);
      if (tokenData && tokenData.accessToken) {
        setAccessToken(tokenData.accessToken);
        v4Service.setToken(tokenData.accessToken);
      }
    };

    retrieveToken();
  }, [storedDataKey]);

  return {
    accessToken,
  };
};
